module.exports = __webpack_public_path__ + "img/Advantage2.60549b39.png";